import { useAppStore } from "../../stores/RootStore";
import { useFetch } from "../useFetch";
import { useEffect } from "react";
import { EquipmentModel } from "../../types/types";

export const useEquipmentModels = () => {
  const setEquipmentModels = useAppStore((state) => state.setEquipmentModels);

  const [{ response: equipmentModelsData }, doFetchEquipmentModels] = useFetch(
    "/directories/equipment_models"
  );

  useEffect(() => {
    let equipmentModels = equipmentModelsData?.data as unknown as EquipmentModel[];
    if (equipmentModels) setEquipmentModels(equipmentModels);
  }, [equipmentModelsData]);

  return doFetchEquipmentModels;
};
